export const HAKLAI_TAB_LABELS = Object.freeze({
  dealNumberTitle: "מספר עסקה",
  defaultDescription: "תיאור עסקה"
});
